<template>
  <v-app-bar id="core-toolbar" elevate-on-scroll color="background" app>
    <!-- rounded -->

    <v-img alt="Sharylist Logo" src="@/assets/logo.png" contain max-width="48" position="left" />

    <v-toolbar-title>
      <v-menu v-if="workspaceCurrentIsDefined">
        <!-- offset-y -->
        <template v-slot:activator="{ on, attrs }">
          <v-hover v-slot:default="{ hover }">
            <v-card v-bind="attrs" v-on="on" :flat="!hover" class="ma-1">
              <!--
                :flat="!workspaceShowSelectable && !workspaceShowSelecting"
                @mousedown="workspaceShowSelecting = true"
                @blur="workspaceShowSelecting = false"
              -->
              <div class="some-padding">{{ workspaceCurrent.name }}</div>
            </v-card>
          </v-hover>
        </template>
        <v-list>
          <v-list-item
            v-for="ws in workspacesAccessible"
            :key="ws.id"
            @click="workspaceCurrentChange(ws)"
          >
            <v-list-item-title>{{ ws.name }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <div v-else class="ma-1 some-padding">
        {{ titleWorkspaceCurrentNotDefined }}
      </div>
      <!-- <v-select
        v-else-if="title.type === 'menu'"
        v-model="workspaceCurrent"
        :items="workspacesAccessible"
        item-text="title"
        return-object
        class="ma-1"
        solo
        :flat="!workspaceShowSelectable"
        hide-details
      >
        <template #selection >
          <span
            @mouseover="workspaceShowSelectable = true"
            @mouseout="workspaceShowSelectable = false"
          >
            {{ workspaceCurrent.name }}
          </span>
        </template>
      </v-select> -->
    </v-toolbar-title>

    <v-breadcrumbs
      v-show="breadcrumbs.length && $vuetify.breakpoint.mdAndUp"
      :items="breadcrumbs"
      large
    >
      <template #divider>
        <v-icon>mdi-chevron-right</v-icon>
      </template>
      <template #item="{ item }">
        <v-breadcrumbs-item :to="item.to" class="text-truncate" style="max-width: 16ch;">
          <v-icon left>{{ item.icon }}</v-icon>
          {{ item.text }}
          <!-- {{ item.text.toUpperCase() }} -->
        </v-breadcrumbs-item>
      </template>
    </v-breadcrumbs>

    <v-spacer></v-spacer>

    <!-------------------------##-- CoreToolbarActions.vue --##-------------------------------->
    <core-toolbar-actions />
  </v-app-bar>
</template>

<script>
import { mapState, mapMutations } from 'vuex'
import Logger from '@/lib/Logger'

import User from '@/models/User'
// import Session from '@/models/Session'

import CoreToolbarActions from '@/components/CoreToolbarActions'

export default {
  components: {
    CoreToolbarActions,
  },

  data: () => ({
    workspacesAccessible: [
      //   {
      //     id: '1',
      //     title: 'Personal',
      //   },
      //   {
      //     id: '4',
      //     title: 'Shared1',
      //   },
      //   {
      //     id: '2',
      //     title: 'Invited1',
      //   },
      //   {
      //     id: '3',
      //     title: 'Invited2',
      //   },
    ],
    // workspaceShowSelectable: false,
    // workspaceShowSelecting: false,
    //
  }),

  computed: {
    breadcrumbs() {
      let breadcrumbs = []
      if (this.nodeCurrent.workspace.id) {
        breadcrumbs.push({
          icon: 'mdi-view-dashboard',
          // text: 'Dashboard',
          to: '/dashboard/' + this.nodeCurrent.workspace.id,
        })
        if (this.nodeCurrent.master.id) {
          breadcrumbs.push({
            icon: 'mdi-vector-square',
            text: this.nodeCurrent.master.title,
            to: '/model/' + this.nodeCurrent.master.id,
          })
          if (this.nodeCurrent.instance.id) {
            breadcrumbs.push({
              icon: 'mdi-format-list-checks',
              text: this.nodeCurrent.instance.title,
              to: '/checklist/' + this.nodeCurrent.instance.id,
            })
          }
        }
      }
      return breadcrumbs
    },
    titleWorkspaceCurrentNotDefined() {
      if (
        this.$route.name == 'Login' ||
        this.$route.name == 'Registration' ||
        this.$route.name == 'RegistrationAcknowledge'
      ) {
        return 'Sharylist'
      } else {
        return this.$route.name
      }
    },
    workspaceCurrentIsDefined() {
      return this.workspaceCurrent.id != ''
    },
    ...mapState({
      // title: state => state.coreToolbar.title,
      // userLogged: state => state.userLogged,
      userLoggedId: state => state.userLogged.id,
      workspaceCurrent: state => state.nodeCurrent.workspace,
      nodeCurrent: state => state.nodeCurrent,
    }),
  },

  watch: {
    async userLoggedId(/*to, from*/) {
      // react to logged user changes...
      this.queryCreate()
    },
  },

  created() {
    this.queryCreate()
  },

  mounted() {
    // Logger.debug('Toolbar mounted')
  },

  beforeDestroy() {
    this.queries.forEach(q => q.destroy())
  },

  methods: {
    queryCreate() {
      if (this.queries) this.queries.forEach(q => q.destroy())
      if (this.userLoggedId) {
        this.queries = [
          User.find({
            get:
              '{ id, workspacesPrivate { id, name }, workspacesShared { id, name }, workspacesInvited { id, name } }',
            by: { id: this.userLoggedId },
            onChange: data => {
              this.workspacesAccessible = [
                ...data.workspacesPrivate,
                ...data.workspacesShared,
                ...data.workspacesInvited,
              ]
              // FIXME: a rischio per la reattività
              Logger.debug('Ecco i workspace accessibili', data, this.workspacesAccessible)
            },
            onError: error => {
              Logger.error('ERROR in loading data:', error)
              this.toastSet({
                message: 'Error in loading data',
                color: 'error',
              })
            },
          }),
        ]
      }
    },
    workspaceCurrentChange(workspaceSelected) {
      if (workspaceSelected.id != this.workspaceCurrent.id) {
        this.nodeCurrentSet({
          workspace: {
            id: workspaceSelected.id,
            name: workspaceSelected.name,
          },
        })
        this.goToDashboard(workspaceSelected.id)
      }
    },
    goToDashboard(workspaceId) {
      this.$router.push({ name: 'Dashboard', params: { workspaceId: workspaceId } })
    },
    ...mapMutations(['toastSet', 'nodeCurrentSet']),
  },
}
</script>

<style scoped>
.some-padding {
  padding: 0.7ch 1.5ch;
}
/* #core-toolbar {
  background-color: var(--v-background);
} */
/* #core-toolbar a {
  text-decoration: none;
} */
</style>
